module.exports = __webpack_public_path__ + "img/signature.d30d78e3.png";